export default "__VITE_ASSET__e1332ce3__"